import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "angle-left",
  "use": "angle-left-usage",
  "viewBox": "0 0 266 438",
  "content": "<symbol viewBox=\"0 0 266 438\" xmlns=\"http://www.w3.org/2000/svg\" id=\"angle-left\"><path d=\"M7.524 202.029L201.867 7.686c9.373-9.373 24.569-9.373 33.941 0l22.667 22.667c9.357 9.357 9.375 24.522.04 33.901L104.495 219l154.021 154.745c9.335 9.379 9.317 24.544-.04 33.901l-22.667 22.667c-9.373 9.373-24.569 9.373-33.941 0L7.525 235.97c-9.373-9.372-9.373-24.568 0-33.941z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol